export const PERSONA_JURIDICA = 'PERSONA_JURIDICA';
export const PERSONA_MORAL = 'PERSONA_MORAL';
export const NIT = 'NIT';
export const CC = 'CC';
export const IVA_NO_RESPONSABLE = 'NO_RESPONSABLE_IVA';
export const RESPONSABLE_IVA = 'RESPONSABLE_IVA';
